export enum ORDER_EDITOR_REASON {
  Create = "Create",
  Correction = "Correction",
  Edit = "Edit",
  Preview = "Preview",
  InvoiceEdit = "InvoiceEdit",
  Clone = "Clone", // User only in API
  FormalCorrection = "FormalCorrection",
}
